import { ChangeDetectionStrategy, Component, input, output, InputSignal, OutputEmitterRef } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-scanning-agent-debug-mode-switch',
  templateUrl: './scanning-agent-debug-mode-switch.component.html',
  imports: [CommonModule, SharedModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScanningAgentDebugModeSwitchComponent {
  public readonly value: InputSignal<boolean> = input<boolean>(false);
  public readonly valueChange: OutputEmitterRef<boolean> = output<boolean>();

  public onValueChange(newValue: boolean): void {
    this.valueChange.emit(newValue);
  }
}
